export default __webpack_public_path__ + "i18n/translation-en.23dfcc94.json";